// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import { type ResourceAction } from '../resourceAIandRD/Resource.types'

const contactSupport: any = process.env.CONTACT_SALES_URL

export interface TextContent {
  type: 'list' | 'text'
  content: any
}

export interface TextBlockTemplate {
  title: string
  subTitle?: string
  subTitleTop?: string
  text: TextContent
  action?: ResourceAction
}

export const initialTextBlocks: TextBlockTemplate[] = [
  {
    title: 'Gaudi 2 or 3',
    subTitleTop: 'AI Processor Instances',
    subTitle: 'Starting at $1.30 / hr / card',
    text: {
      type: 'list',
      content: ['Bare metal on Xeon Gen 6', 'Memory: 2TB', 'Disk: 17TB', 'Cards: 8 AI processors']
    },
    action: { label: 'Learn more', type: 'button', redirectTo: '/pricing#ai-accelerator-title' }
  },
  {
    title: 'Max Series GPU',
    subTitleTop: 'GPU Instances',
    subTitle: 'Starting at $0.39 / hr / card',
    text: { type: 'list', content: ['Bare metal on Xeon Gen 5', 'Memory: 2TB', 'Disk: 1TB', 'Cards: 8 GPUs'] },
    action: { label: 'Learn more', type: 'button', redirectTo: '/pricing#gpu-instances-title' }
  },
  {
    title: 'Xeon Gen 4, 5 or 6',
    subTitleTop: 'CPU',
    subTitle: 'Starting at $0.45 / hr',
    text: { type: 'list', content: ['Bare metal on Xeon Scalable', 'Memory: 1TB', 'Disk: 1TB'] },
    action: { label: 'Learn more', type: 'button', redirectTo: '/pricing#cpu-instances-title' }
  },
  {
    title: 'Clusters and more',
    subTitleTop: 'Custom',
    subTitle: '',
    text: {
      type: 'text',
      content: 'Customized pricing for Gaudi clusters and discounted reserved pricing can be provided on request.'
    },
    action: {
      label: 'Talk to Sales',
      type: 'button',
      redirectTo: contactSupport,
      variant: 'primary',
      openInNewTab: true
    }
  }
]
